import { Logo } from 'src/Components/Logo';

import styles from './FullScreenFormWrapper.module.scss';
import { Props } from './FullScreenFormWrapper.types';

const FullScreenFormWrapper = ({ children, maxWidth }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.content} style={{ '--content-max-width': `${maxWidth ?? 700}px` }}>
        <div className={styles.logoContainer}>
          <Logo variant="wordmark" className={styles.textLogo} />
        </div>
        <div className={styles.children}>{children}</div>
      </div>
    </div>
  );
};

export default FullScreenFormWrapper;
